import { useAuthStore } from '../store';
import { UserInfo } from '@/types/auth';

/**
 * Hook to access current user info
 */
export const useUser = (): { user: UserInfo | null; isLoading: boolean } => {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);
  
  return { user, isLoading };
};
